<template>
<div>
  <RecordNotFound v-if="status_code==404" :message="status_message"></RecordNotFound>
  <div v-else class="invoice-create-page">
    <!--  credit form component -->

    <InvoicePaymentForm
      page="invoice"
      :submitted="submitted"
      :duplicatecode="duplicatecode"
      :lists="lists"
      v-on:onSubmit="onSubmit($event)"
    >
      <!-- footer block -->
    </InvoicePaymentForm>
    </div>
  </div>
</template>
 
<script scoped>
import InvoicePaymentForm from "@/components/Form/PaymentsReceived/PaymentForm"; // payment form for update payment record
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState } from "vuex"; // get data set in the state in vuex
import RecordNotFound from "@/pages/Error/RecordNotFound";
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling notification
export default {
  mixins: [notificationMixin, formatDate],
  name: "Records", // page name
  components: {
    InvoicePaymentForm,
    RecordNotFound
  },
  data() {
    return {
      lists: "",
      submitted: false,
      duplicatecode: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },
  methods: {
    //validation during onsubmit
    onSubmit(data) {
      this.submitted = true;
      this.$store
        .dispatch("invoice/updatePayment", {
          id: this.$route.params.id,
          field: data
        })
        .then(() => {
          var message, type;
          if (this.status_code == 404) {
           window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.status_message,
              type: this.status_type,
              showCloseButton: true
            });
          }
          if (this.status_code == 200) {
            //  show if invoice successfully created
            if(this.$route.query.page=='recurring'){
               this.$router.push({
              name: "RecurringInvoiceView",
              params: {
                id:this.$route.query.rec_id
              }
             });
            }
            else{
            this.$router.push({
              name: "InvoiceView",
               params: {
                id:this.$route.params.id
              }
            });
            }
            this.submitted = false;
            //  code for notificatin display
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.status_message,
              type: this.status_type,
              showCloseButton: true
            });
          } else {
            this.duplicatecode = true;
            this.submitted = false;
          }
        })
        .catch(() => {});
    }
  },
  created() {
    this.initializationMessengerCode();
    this.lists = {
      cus_id: this.list.invoice_header_detail.cus_name,
      cus_currency: this.list.invoice_header_detail.cus_currency,
      is_export: this.list.invoice_header_detail.is_export,
      unit_currency_value: this.list.invoice_header_detail.unit_currency_value,
      pymnt_date: this.formatDate(new Date()),
      bank_charges: parseFloat(0).toFixed(2),
      pymnt_mthd: "1",
      deposit_mthd:"",
      is_tax_deducted: 0,
      tns_no: "",
      due_amount: parseFloat(
        this.list.invoice_amount_detail.due_amount
      ).toFixed(2),
      paid_amount: parseFloat(
        this.list.invoice_amount_detail.due_amount
      ).toFixed(2),
      list_no: this.list.invoice_header_detail.inv_no,
      disabled: false
    };
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store
      .dispatch(
        "payment/fetchPaymentmethod",
        JSON.stringify({
          type: "payment_received"
        })
      )
      .then(() => {
        next();
      });
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      list: state => state.invoice.list,
      code: state => state.invoice.code,
      status_code: state => state.invoice.status_code, 
      status_message: state => state.invoice.status_message, 
      status_type: state => state.invoice.status_type 
    })
  }
};
</script>